module.exports = __webpack_public_path__ + "img/banner3.e7246528.png";